import React, {  Component } from 'react';
import { connect } from 'react-redux';

/*Actions*/
import {
	validateWarehouseCode
} from '../../redux/actions';

class ChangeDeliveryMethodOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			warehouseCode: '',
			warehouseCodeDetais: null,
			errorMessage: '',
        }
    }

    closeDialog(event) {
        event && event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('ChangeDeliveryMethodOverlayDialog', false);
    }

    componentDidMount() {
		const self = this;
		self.setState({
			showDialog: self.props.showDialog
		});
    }

	handleChangeWarehouseCode(event) {
		this.setState({
			warehouseCode: event.target.value,
			errorMessage: '',
		});
	}

	handleSubmit(event) {
		event.preventDefault();
		const self = this;
		const { warehouseCode } = self.state;
		if(warehouseCode.length !== 3) {
			self.setState({
				errorMessage: 'please enter 3 character warehouse code.'
			});
		} else {
			// make service call to validate warehouse code
			self.props.validateWarehouseCode(`requestType=getWarehouseDetails&warehouseCode=${warehouseCode.toUpperCase()}`, resp => {
				if (resp.status && resp.responseObject && resp.responseObject.facilitycoreresponse && resp.responseObject.facilitycoreresponse.length) {
					self.props.handleUpdateWarehouseDetails(resp.responseObject.facilitycoreresponse[0]);
					self.closeDialog();
				} else {
					self.setState({
						errorMessage: 'Invalid warehouse code.'
					});
				}
			});
		}
	}

    render() {
		const self = this;
		const { errorMessage } = self.state;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="availabilityDetailsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Location</h2>
					{errorMessage && <p className="red bold">{errorMessage}</p>}
					<table>
						<tbody>
							<tr>
								<td>
									<strong>Warehouse Code</strong>
								</td>
								<td>
									<input name="warehouseCode" onKeyPress={this.props.acceptAlphaNumericOnly} onChange={this.handleChangeWarehouseCode.bind(this)} maxLength="3" />
								</td>
							</tr>
						</tbody>
					</table>
					<div>
						<div className="noButtonContainer">
							<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
						</div>
						<div className="yesButtonContainer">
							<a className="blueButton yesButton" onClick={this.handleSubmit.bind(this)}>Submit</a>
						</div>
					</div>
                 </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	validateWarehouseCode: (payload, callback) => dispatch(validateWarehouseCode(payload, callback)),
});

ChangeDeliveryMethodOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(ChangeDeliveryMethodOverlayDialog);
export default ChangeDeliveryMethodOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeDeliveryMethodOverlayDialog.js